<script>
export default {
    props: {
     title: {
      type: String,
      default: ''
    },
    firstName: {
      type: String,
      default: ''
    },
    secondName: {
      type: String,
      default: ''
    },

    categories: {
      type: Array,
      default: () => []
    },

    data: {
      type: Array,
      default: () => []
    },

    dataTotal: {
      type: Array,
      default: () => []
    },

  },

  computed:{
    minChartZoom(){
      return process.env.VUE_APP_CONSTANT_CHART_ZOOM;
    },
    ifDefaultTheme(){
      return  process.env.VUE_APP_THEME == 0
    },

    
  series() {
    if (this.ifDefaultTheme) {
      return [
        {
          name: this.firstName,
          data: this.data,
        },
        {
          name: this.secondName,
          data: this.dataTotal,
        },
      ];
    } else {
      return [
        {
          name: this.firstName,
          data: this.data,
          type: 'bar',
        },
        {
          name: this.secondName,
          data: this.dataTotal,
          type: 'bar',
        },
        {
          name: this.firstName,
          data: this.data,
          type: 'line',
        },
      ];
    }
  },

    
  chartOptions() {
    if (this.ifDefaultTheme) {
      return {
            chart: {
              height: 350,
              type: 'area',
              zoom: {
              enabled: true,
              autoScaleYaxis: true,
              
            }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth'
            },
            xaxis: {
              type: 'number',
              categories: this.categories ,
              min:this.minChartZoom ,
          
            },
            yaxis: {
              title: {
                text: 'CA (TND)'
              },
              labels: {
              formatter: function (value) {
                  return Math.round(value); 
              }
          }
        
            },
            tooltip: {
              y: {
                formatter: function (val) {
                    return "TND " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
              }
            },

            title: {
            text: this.title, 
            align: 'left',
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#333'
          }
        },
      };
    } else {
      return {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '20%',
          },
        },
        chart: {
          type: 'bar',
          height: 350,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          show: true,
          dashArray: [0, 0,8],

          width: 2,
          colors: ['#4f81bd', '#27AE60', '#4f81bd'],
        },
        xaxis: {
          type: 'number',
          categories: this.categories,
          min: this.minChartZoom,
        },
        yaxis: {
          title: {
            text: 'CA (TND)',
          },
          labels: {
            formatter(value) {
              return Math.round(value);
            },
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              return 'TND ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
          },
        },
        colors: ['#4f81bd', '#27AE60', '#ddd'],
        title: {
          text: this.title,
          align: 'left',
          style: {
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#333',
          },
        },
      };
    }
  },

  },

  data() {
    return {
    };
  },
};
</script>

<template>
  <div id="chart">
        <apexchart :type="ifDefaultTheme ? 'area' : 'bar' "  height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
</template>
